import { Component, h, Prop } from '@stencil/core';
import { CssClassMap } from '../globals';

@Component({
  tag: 'yth-stack',
  styleUrl: 'yth-stack.scss',
  shadow: true,
})
export class YthStack {
  /**
   * The direction of the stack.
   */
  @Prop({ reflect: true }) direction?:
    | 'column'
    | 'column-reverse'
    | 'row'
    | 'row-reverse' = 'row';

  /**
   * The wrap of the stack.
   */
  @Prop({ reflect: true }) wrap?: 'no-wrap' | 'wrap' | 'wrap-reverse' =
    'no-wrap';

  /**
   * How the stack should justify its content.
   */
  @Prop({ reflect: true }) justifyContent?:
    | 'start'
    | 'end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly' = 'start';

  /**
   * How the stack should align items.
   */
  @Prop({ reflect: true }) alignItems?:
    | 'stretch'
    | 'start'
    | 'end'
    | 'center'
    | 'baseline' = 'stretch';

  /**
   * How the stack should align its content.
   */
  @Prop({ reflect: true }) alignContent?:
    | 'normal'
    | 'start'
    | 'end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'stretch' = 'normal';

  /**
   * How big or small the gap should be between items in the stack.
   */
  @Prop({ reflect: true }) gap?:
    | 'wide'
    | 'default'
    | 'narrow'
    | 'condensed'
    | 'extra-condensed'
    | 'zero' = 'default';

  render() {
    return (
      <div class={this.getCssClassMap()}>
        <slot></slot>
      </div>
    );
  }

  private getCssClassMap(): CssClassMap {
    return {
      [this.direction]: true,
      [this.wrap]: true,
      [`justify-content-${this.justifyContent}`]: true,
      [`align-items-${this.alignItems}`]: true,
      [`align-content-${this.alignContent}`]: true,
      [`gap-${this.gap}`]: true,
    };
  }
}
